@if (config.showHeader) {
  <div class="event-box-header-bar flex flex-between-center">
    <h4 class="event-box-title font-bold" data-test-id="event-box-header">{{ config.texts.header }}</h4>
    <div class="flex flex-end-center gap-24">
      <a
        [queryParams]="{ filter: 'upcoming' }"
        class="small-button"
        color="primary"
        data-test-id="event-box-link"
        mat-button
        routerLink="/events"
        type="button"
      >
        {{ config.texts.allEventsButton }}
      </a>
    </div>
  </div>
}
@for (e of eventsList; track e) {
  <event-box-element
    [event]="e"
    [ngClass]="{
      'visible-mobile': config.hideSwipeForMobile,
      hidden: !config.hideSwipeForMobile && (mediaQueryService.breakpoints$ | async).ltMd,
    }"
    data-test-id="event-box-element-desktop"
  ></event-box-element>
}
@if (!eventsList.length) {
  <div class="no-events-container">
    <p>{{ config.texts.noEvents }}</p>
  </div>
}

<!-- only for mobile -->
@if (eventsList.length > 0 && !config.hideSwipeForMobile) {
  <swipe-list class="block md:hidden">
    @for (e of eventsList; track e) {
      <event-box-element [event]="e" class="swipeEl" data-test-id="event-box-element-mobile"></event-box-element>
    }
  </swipe-list>
}
